// extracted by mini-css-extract-plugin
export default {"mainDiv":"Wings_mainDiv__ZjirB","checkbox":"Wings_checkbox__UkfJb","container":"Wings_container__b4KyV","checkmark":"Wings_checkmark__JyqQv"};